<div class="modal" *ngIf="showModal" [ngClass]="showModal ? 'is-active' : ''">
  <div class="modal-background" (click)="closeModal()"></div>
  <div class="modal-content" [ngClass]="modalClass" [style.width]="customWidth + 'px'">
    <button class="button is-secondary modal-close" (click)="closeModal()"><i class="unreel-feather-close"></i></button>
    <ng-content></ng-content>
  </div>
</div>
